import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } 			  from '@angular/core';
import { Router, ActivatedRoute }                                 from '@angular/router';
import { first, timeout }                                         from 'rxjs/operators';
import { NgxSpinnerService }                                      from 'ngx-spinner';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { AlertService, ExamService, LunchpageService }            from '../_services';
import { Globals  }                                               from '../_helpers';
import config                                                     from '../../config';

@Component({
  selector: 'student-start-practical',
  templateUrl: './practical-launch-page.component.html',
})

export class PracticalLaunchpageComponent implements OnInit, AfterViewInit{
    @ViewChild('practicalStart') private practicalStart: SwalComponent;
    public alertOption: SweetAlertOptions = {};

	userData = {};
	settings = {};
	instructions = [];
	loading = false;
	isCalled = true;
	returnUrl : string;
    isAllowViva = false;
    isTheory = false;
    geoIPData = {};
    geoIP = '';
    city = '';
    region = '';
    postal = '';
    loc = '';
    countryip = ''; 
    videostream = 0;    
    vcsettings = {};
    keys : any;
    counter : number = 0;
    studentName: string = '';
    studentCode: string = '';	

	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private lunchpageService: LunchpageService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private examService: ExamService,       
    ) {}

    ngOnInit() {

        var step = this.route.snapshot.paramMap.get("step");
        if(step != this.globals.complSteps['practical-start'])
            //this.router.navigateByUrl('/login');

        if(this.globals.isExamOver)
            this.router.navigateByUrl('/login');
       
        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_vc_set);   
        this.studentName = this.userData['name'];
        this.studentCode = this.userData['code'];
        /* call function for to get practical info */
        this.getPractical(); 
        
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';          
    }
/*  ngAfterViewInit(): void {  
    this.vcsettings = JSON.parse(sessionStorage.pkshn_vc_setting);
    if(typeof this.vcsettings != undefined || typeof this.vcsettings != 'undefined')
    { 
        if(this.vcsettings['sid'] == 0 && this.vcsettings['tid'] == 0)
        {
            setTimeout(function () {
                this.getPractical(); 
            }, 3000);
        }
    } 
  } */

    /* Get Practical data when UI is load */
    private getPractical() {
        this.loading = true;
        this.spinner.show();
        this.examService.getPracticalInfo(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['examid'], this.settings['practicalid'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        //let vc_counter = data.vc_counter;
                        let videoFeed = data.feed;
                        let vcsetting = {'sid':videoFeed.session, 'tid':videoFeed.token, 'vccount': data.vc_counter};
                        sessionStorage.setItem('pkshn_vc_setting',JSON.stringify(vcsetting));
                        //this.setVideoPublish(videoFeed.token,videoFeed.session);
                        this.loading = false;
                        this.spinner.hide();                        
                    }
                    else if (data.code == 1001) {
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                        this.spinner.hide();
                    }
                    else {
                        this.loading = false;
                        this.spinner.hide();
                    }

                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                    //this.router.navigateByUrl('/login');
                    this.spinner.hide();
                }
            );
    }

    public startPractical(){
        var parms = this.globals.getRandUrl('practical-start');
        this.router.navigateByUrl('/practical-start/'+parms);
    } 
    public startPracticalAuto(){
        var parms = this.globals.getRandUrl('practical-start');
        this.router.navigateByUrl('/practical-start/'+parms);
    }    
    public getKeys(){
        this.examService.getPracticalInfo(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['examid'], this.settings['practicalid'])
            .pipe(first())
            .subscribe(
                data => {
                    if (data.code == 1000) {
                        let vc_counter = data.vc_counter;
                        let videoFeed = data.feed;
                        let vcsetting = {'sid':videoFeed.session, 'tid':videoFeed.token, 'vccount': data.vc_counter};
                        sessionStorage.setItem('pkshn_vc_setting',JSON.stringify(vcsetting));
                        if(videoFeed.session != 0)
                        {
                            this.keys = videoFeed.session; 
                            this.counter = 1;
                            this.practicalStart.show();                     
                        }
                    }
                },
                error => {
                    //this.alertService.error(error);
                    //this.loading = false;
                    //this.router.navigateByUrl('/login');
                    //this.spinner.hide();
                }
            );
      }  
    ngAfterViewInit(): void {  
        //this.getKeys();
        this.keys = setInterval(() => {
            if(this.counter > 0)
            {
                clearInterval( this.keys );
            }
            else
            {
                this.getKeys(); 
            }
        }, 3000);         
    }   
    public logout(){
        this.router.navigateByUrl('/login')
    } 

}
